import type { ContainerConfig } from '../../components/container-types/types';

const isModalType = (containerConfig?: ContainerConfig) => {
  return containerConfig?.type === 'modal';
};

export default isModalType;
